import { TOURNAMENT_TYPE } from '@/model/TournamentType'
import { Game, GameUi, MetaData } from '@/model/Tournament'
import { gdcConverter } from '@gd/currency-converter'

export const tournamentDefaultImages: { [gametype: string]: string } = {
  ska: 'skat',
  rom: 'romme',
}

export function isMasters(zoneId: string) {
  return /masters/.test(zoneId)
}

export function isInternal(zoneId: string) {
  return /_gd/.test(zoneId)
}
export function getTournamentType(gametype: string, zoneId: string): TOURNAMENT_TYPE {
  if (gametype === 'rom') {
    if (isMasters(zoneId)) {
      return isInternal(zoneId) ? TOURNAMENT_TYPE.ROM_MASTERS_GD : TOURNAMENT_TYPE.ROM_MASTERS
    } else {
      return isInternal(zoneId) ? TOURNAMENT_TYPE.ROM_TOURNAMENT_GD : TOURNAMENT_TYPE.ROM_TOURNAMENT
    }
  } else if (gametype === 'ska') {
    if (isMasters(zoneId)) {
      return isInternal(zoneId) ? TOURNAMENT_TYPE.SKA_MASTERS_GD : TOURNAMENT_TYPE.SKA_MASTERS
    } else {
      return isInternal(zoneId) ? TOURNAMENT_TYPE.SKA_TOURNAMENT_GD : TOURNAMENT_TYPE.SKA_TOURNAMENT
    }
  } else if (gametype === 'bel') {
    return TOURNAMENT_TYPE.BEL_TOURNAMENT_GD
  }
  return TOURNAMENT_TYPE.NOT_MATCHING
}

export function createGamesUi(games: Array<Game>, numberOfGames: number): Array<GameUi> {
  const gamesUi: Array<GameUi> = games.map((game: Game, idx: number) => {
    return {
      ...game,
      idx,
    }
  })
  for (let index = gamesUi.length; index < numberOfGames; index++) {
    gamesUi.push(createGameUiStub(index))
  }
  return gamesUi
}

export function createGameUiStub(index: number) {
  return { competitionId: '', state: 'open', score: 0, rank: 0, idx: index }
}

export function formatMetaData(metaData: MetaData, gdc: string, gametype: string): MetaData {
  return {
    ...metaData,
    entryFee: gdcConverter(metaData.entryFee, { gdc }),
    restartFee: gdcConverter(metaData.restartFee, { gdc }),
    totalWin: gdcConverter(metaData.totalWin, { gdc }),
    image: metaData.image || tournamentDefaultImages[gametype],
  }
}
